import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'app-user-email-verify',
  imports: [CardModule, ButtonModule],
  templateUrl: './user-email-verify.html',
  styleUrl: './user-email-verify.css'
})
export class UserEmailVerify implements OnInit {
  token: string | null = null;

  constructor(private route: ActivatedRoute, 
      private accountService: AccountService,
      private router: Router) {}

  ngOnInit() {
    // Read the token from query string parameters
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (this.token) {
      console.log('Token from query string:', this.token);
      this.accountService.verifyEmail(this.token).subscribe((response) => {
        console.log('Response from verifyEmail:', response);
      });
    }
  }

  navigateToDashboard() {
    this.router.navigate(['/app']);
  }

  navigateToLogin() {
    this.router.navigate(['/login-user']);
  }
}
